import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'

import { seoFragment } from '../fragments/seo.js'

export const getBlogPage = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  query GetBlogPage(
    $locale: SiteLocale
    $filter: ArticleModelFilter
    $first: IntType
    $skip: IntType
  ) {
    blogListing(locale: $locale) {
      titleImage {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
      subtitle
      seo {
        ...SeoFragment
      }
      carousel {
        id
        slides {
          id
          pretitle
          title
          image {
            landscape: responsiveImage(
              imgixParams: { fit: crop, w: 1920, h: 1080, ar: "16/9", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
            portrait: responsiveImage(
              imgixParams: { fit: crop, w: 1536, h: 2048, ar: "9/16", fm: webp }
            ) {
              ...ResponsiveImageFragment
            }
          }
          linkUrl
          linkText
        }
      }
    }
    allArticles(locale: $locale, filter: $filter, first: $first, skip: $skip) {
      id
      title
      slug
      inEvidenza
      intro
      tag {
        id
        slug
        title
      }
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    article(locale: $locale, filter: { inEvidenza: { eq: "true" } }) {
      id
      title
      slug
      intro
      inEvidenza
      tag {
        id
        slug
        title
      }
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    allBlogTags(locale: $locale) {
      title
      slug
      id
    }
    _allArticlesMeta(locale: $locale, filter: $filter) {
      count
    }
  }
`

export const getArticle = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  query GetArticle(
    $locale: SiteLocale
    $filter: ArticleModelFilter
    $filterOthers: ArticleModelFilter
  ) {
    blogListing(locale: $locale) {
      titleImage {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
    article(locale: $locale, filter: $filter) {
      _allSlugLocales(fallbackLocales: it) {
        value
        locale
      }
      seo {
        ...SeoFragment
      }
      id
      title
      slug
      tag {
        title
        slug
      }
      quote {
        id
        text
        overlapText
        isDark
      }
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
      articoliCorrelati {
        id
        title
        slug
        inEvidenza
        intro
        tag {
          id
          slug
          title
        }
        image {
          id
          responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
            ...ResponsiveImageFragment
          }
        }
      }
      body {
        value
        blocks {
          ... on FullscreenVideoRecord {
            id
            overlayFullVideo
            previewVideo
            previewVideoMobile
            showMuteUnmute
          }
          ... on FullscreenImageRecord {
            id
            image {
              landscape: responsiveImage(
                imgixParams: {
                  fit: crop
                  w: 1920
                  h: 1080
                  ar: "16/9"
                  fm: webp
                }
              ) {
                ...ResponsiveImageFragment
              }
              portrait: responsiveImage(
                imgixParams: {
                  fit: crop
                  w: 1536
                  h: 2048
                  ar: "9/16"
                  fm: webp
                }
              ) {
                ...ResponsiveImageFragment
              }
            }
            imageMobile {
              id
              alt
              custom: responsiveImage(
                imgixParams: { fm: webp, q: "60", fit: crop }
              ) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
      }
    }
    allArticles(locale: $locale, filter: $filterOthers, first: 6) {
      id
      title
      slug
      inEvidenza
      intro
      tag {
        id
        slug
        title
      }
      image {
        id
        responsiveImage(imgixParams: { auto: format, q: "60", fit: crop }) {
          ...ResponsiveImageFragment
        }
      }
    }
  }
`
